module.exports = __webpack_public_path__ + "static/media/person-working.bcca9bdd.png";